import request from '@/utils/request'

// 获取列表
export function listProduct(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF051', ...data }
  })
}
// 获取产品协议内容
export function productAgreement(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF052', ...data }
  })
}
// 获取产品图文描述
export function productContent(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF053', ...data }
  })
}
// 全流程
export function getProductQuota(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF207', ...data },
    loading: true
  })
}
export function getProductLoanUrl(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'UC007', ...data }
  })
}
export function getProductRepayUrl(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'UC008', ...data }
  })
}
// 获取产品信息
export function productInfo(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF054', ...data }
  })
}
export function h5CheckIn(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'SF209', ...data },
    loading: true
  })
}


export function getShooppingMerchant() {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'BL312' },
    loading: true
  })
}

//获取商店产品分类列表

export function getStoreCategory(data) {
  console.log(data,'2222')
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'MS003', ...data },
    loading: true
  })
}

// 商店商品列表（分期商城）
export function getStoreGoodsList(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'MS001', regionType: 'DOWN_PAYMENT', ...data }
  })
}

// 三方商城商品列表
export function getThirdMallGoodsList(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'IMS91', regionType: 'DOWN_PAYMENT', ...data }
  })
}

// 三方商城商品详情
export function getThirdMallGoodsDetail(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'IMS92', regionType: 'DOWN_PAYMENT', ...data },
    loading: true
  })
}

// 三方商城商品分类
export function getThirdMallCategory(data) {
  return request({
    url: '/znbj/gateway',
    method: 'post',
    data: { apiCode: 'IMS93', ...data },
    loading: true
  })
}
